// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrencyShortageBlock_wrapper","currency":"CurrencyShortageBlock_currency","plus":"CurrencyShortageBlock_plus","more":"CurrencyShortageBlock_more"};